module.exports = __webpack_public_path__ + "img/kiba_smoothie.fac231cf.jpg";